(function () {
    'use strict';

    angular.module('app.users', [
        'app.core',
        'components.form',
        'components.api',
        'toastr'
    ]);
})();